import React, { useState } from "react";
import styles from "./input.module.css";
import { MyIcons } from "../../icons/my-icons";

const Input = ({
  label,
  type = "text",
  value,
  onChange,
  placeholder,
  name,
  style,
  isSearch = false,
  inputStyle,
  wrapperStyle,
  onKeyPress,
  disabled,
  readOnly,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const stringValue = value != null ? String(value) : '';
  const hasContent = stringValue.trim() !== "";
  const isPassword = type === "password";
  const inputType = isPassword && showPassword ? "text" : type;

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div
      className={`${styles.inputContainer} ${
        isSearch ? styles.searchContainer : ""
      }`}
      style={style}
    >
      {label && (
        <label htmlFor={name} className={styles.label}>
          {label}
        </label>
      )}
      <div
        className={`${styles.inputWrapper} ${
          hasContent ? styles.hasContent : styles.noContent
        }`}
        style={wrapperStyle}
      >
        {isSearch && (
          <div
            style={{
              marginTop: "auto",
              marginBottom: "auto",
              alignItems: "center",
              display: "flex",
            }}
          >
            <MyIcons
              name="search"
              height={20}
              width={20}
              color={"var(--dark-grey)"}
            />
          </div>
        )}
        <input
          name={name}
          type={inputType}
          style={inputStyle}
          value={stringValue}
          onChange={onChange}
          onKeyPress={onKeyPress}
          placeholder={placeholder}
          className={`${styles.input} ${isSearch ? styles.searchInput : ""}`}
          disabled={disabled}
          readOnly={readOnly}
          spellCheck="true"
        />
        {isPassword && (
          <div
            onClick={togglePasswordVisibility}
            style={{
              marginTop: "auto",
              marginBottom: "auto",
              alignItems: "center",
              display: "flex",
              cursor: "pointer",
              padding: "4px",
            }}
          >
            <MyIcons
              name={showPassword ? "eyeOff" : "eye"}
              height={20}
              width={20}
              color={"var(--dark-grey)"}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Input;
